import React from "react";
import OpenSeadragon from "../../js/openseadragon";
import Lang from "../../helpers/Lang";
import SocialSharing from "../SocialSharing/SocialSharing";

class OpenSeaDragonViewer extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    isLoading: true,
  };

  isLoading = () => {
    this.setState({
      isLoading: true,
    });
  };

  render() {
    let self = this;
    let { id } = this.props;

    return (
      <div
        className="ocd-div"
        ref={(node) => {
          this.el = node;
        }}
      >
        <div className="openseadragon" id={id} />
        {this.state.isLoading && (
          <img
            alt='loader'
            className="ocd-loader"
            src="/Web/FrontEndR/assets/gfx/loader-transparent.gif"
          />
        )}
        <button
          type="button"
          className="ocd-button ocd-button-close"
          onClick={this.props.closeModal}
        >
          <span className="visuallyhidden">{Lang.get("close")}</span>
        </button>
        <div className="ocd-buttons">
          <button
            type="button"
            id="prev"
            className="gallery-carousel-prev fullscreen ocd-arrow ocd-button-prev"
            onClick={() => {
              this.isLoading();
            }}
          >
            Forrige
          </button>
          <div className="ocd-center-buttons">
            <button id="zoom-out" className="ocd-button ocd-button-zoom-out">
              <span className="visuallyhidden">{Lang.get("zoomOut")}</span>
            </button>
            <button id="zoom-in" className="ocd-button ocd-button-zoom-in">
              <span className="visuallyhidden">{Lang.get("zoomIn")}</span>
            </button>
            <SocialSharing
              url={window.location}
              additionalLinkCssClasses={"gallery-carousel-share"}
              additionalMenuCssClasses={"social-sharing-list__open-upwards"}
              hideSharingText={true}
            />
            <a
              href={this.props.imgSrcDownload}
              ref="ocdDownloadLink"
              className="ocd-button ocd-button-download"
              download
              role="button"
            >
              <span className="visuallyhidden">Last ned</span>
            </a>
          </div>
          <button
            type="button"
            id="next"
            className="gallery-carousel-next fullscreen ocd-arrow ocd-button-next"
            onClick={() => {
              this.isLoading();
            }}
          >
            Neste
          </button>
        </div>
      </div>
    );
  }

  initSeaDragon() {
    let self = this;
    let { id } = this.props;

    self.viewer = OpenSeadragon({
      id: id,
      visibilityRatio: 1,
      constrainDuringPan: false,
      minZoomLevel: 0,
      maxZoomLevel: 10,
      zoomInButton: "zoom-in",
      zoomOutButton: "zoom-out",
      homeButton: "reset",
      nextButton: "next",
      previousButton: "prev",
      showNavigator: false,
      sequenceMode: true,
      tileSources: this.props.viewItems,
      useCanvas: true,
      minZoomImageRatio: 1,
    });

    self.viewer.goToPage(this.props.slide);
    this.refs.ocdDownloadLink.href = this.props.viewItems[
      this.props.slide
    ].downloadUrl;

    self.viewer.addHandler("page", (data) => {
      if (!(this.props.slide == data.page)) {
        const downloadUrl = this.props.viewItems[data.page].downloadUrl;
        this.refs.ocdDownloadLink.href = downloadUrl;
        self.props.changePage(data.page);
      }
    });

    self.viewer.addHandler("open", function () {
      var tiledImage = self.viewer.world.getItemAt(0);

      if (tiledImage.getFullyLoaded()) {
        self.setState({ isLoading: false });
      } else {
        tiledImage.addOnceHandler("fully-loaded-change", function () {
          self.setState({ isLoading: false });
        });
      }
    });
  }
}

OpenSeaDragonViewer.defaultProps = {
  id: "ocd-viewer",
  type: "legacy-image-pyramid",
};

export default OpenSeaDragonViewer;
